export enum ApplicationStates {
    notInitialized = 'nonInitialized',
    initialized = 'initialized',
    initialNavigationInterupted = 'initialNavigationInterupted',
    initialNavigationComplete = 'initialNavigationComplete',
}
